import React from "react";


import {
    SectionContainerComponent
} from "@Components/Sections";


import {
    FaqQuestionComponent,
    FaqQuestionType
} from "@Pages/FAQ/QuestionList/QuestionElement";


import "./index.scss";


const QuestionsElements:FaqQuestionType[] = [
    {
        questionText: 'Is connecting my inbox safe?',
        answerText: `
            <p>Yes. Email access is read-only by default; we store OAuth tokens encrypted, auto-purge raw email data after 30 days, and follow SOC-2 controls.</p>
        `
    },
    {
        questionText: 'What kinds of refunds can Qyvo find?',
        answerText: `
            <p>C.A.R.E. looks for refundable charges across air & ground travel, lodging, digital subscriptions, retail purchases, financial services, utilities, and event tickets.</p>
        `
    },
    {
        questionText: 'How does it handle non-travel vendors?',
        answerText: `
            <p>The engine scans receipts and service e-mails, identifies refund-worthy fees or overcharges, then files claims directly with those vendors for you.</p>
        `
    },
    {
        questionText: 'Will this hurt my airline or vendor loyalty status?',
        answerText: `
            <p>No. Refunds apply only to taxes, fees, or billing errors; your fare rules, miles, and status points stay intact.</p>
        `
    },
    {
        questionText: 'How much money do people really get back?',
        answerText: `
            <p>A success fee of 25% on cash recovered—no subscriptions and no charge if we don't win you money.</p>
        `
    },
    {
        questionText: 'Does Qyvo ever send e-mails from my address?',
        answerText: `
            <p>Only if you opt-in to our Send As feature (needed for a few airlines/vendors that demand user-originated claims). Every such e-mail appears in your Sent folder, and you can revoke access at any time.</p>
        `
    },
    {
        questionText: 'Do I have to connect my inbox?',
        answerText: `
            <p>No. For travellers who prefer not to grant read-only access, Qyvo supports secure file uploads or a 'forward-your-receipt' address. Just remember: without inbox access C.A.R.E. can't monitor future trips automatically—you'll need to upload each new ticket/document yourself.</p>
        `
    },
    {
        questionText: 'Do I have to connect my inbox?',
        answerText: `
            <p>No. For travellers who prefer not to grant read-only access, Qyvo supports secure file uploads or a 'forward-your-receipt' address. Just remember: without inbox access C.A.R.E. can't monitor future trips automatically—you'll need to upload each new ticket/document yourself.</p>
        `
    },
    {
        questionText: 'What if my vendor isn\'t supported yet?',
        answerText: `
            <p>We're constantly adding new refund opportunities. When a new workflow goes live, C.A.R.E. automatically re-checks your entire e-mail history - no extra steps.</p>
        `
    },
    {
        questionText: 'What if a vendor refuses my refund?',
        answerText: `
            <p>If a vendor misses its legal deadline, the Regulatory Escalation Bot files the appropriate complaint (DOT, CAA, FTC, or equivalent) on your behalf.</p>
        `
    },
    {
        questionText: 'Does Qyvo monitor e-commerce purchases too?',
        answerText: `
            <p>Yes. It identifies refundable charges like late delivery fees, price guarantees, or undelivered goods from major online retailers.</p>
        `
    },
    {
        questionText: 'How often is Qyvo updated?',
        answerText: `
            <p>Weekly. We script new claim forms, expand to additional regions, and enhance security on a rolling basis.</p>
        `
    },
    {
        questionText: 'Can I delete my account?',
        answerText: `
            <p>Absolutely - one click in Settings → Delete Account wipes your data and revokes all access instantly.</p>
        `
    },
];


export const FAQPageQuestionListSection:React.FC = () => {

    const QuestionsList = QuestionsElements.map((Question, i) =>
        <FaqQuestionComponent key={i} Question={Question} />
    );

    return (
        <SectionContainerComponent
            id={'faq-page__questions-list-section'}
            sectionType={'main'}
        >
            {QuestionsList}
        </SectionContainerComponent>
    );

};


export default FAQPageQuestionListSection;
